import React from "react";
import SEO from "components/SEO/SEO";
import { Link } from "react-router-dom";
import "./Guidelines.css";
import guidelinesImg from "assets/about/guidelines.png";

export default function Guidelines() {
  return (
    <>
      <SEO
        title="RBI Guidelines for Debt Recovery | CSR Associates Blog"
        description="Complete guide to RBI Fair Practices Code for loan recovery in India. What banks and collection agencies must follow for ethical, compliant debt collection."
        keywords="RBI guidelines debt recovery, Fair Practices Code India, ethical debt collection India, RBI collections rules, NBFC recovery guidelines"
      />


      <div className="blog-page">
        <div className="container blog-inner">
          <div className="blog-hero" data-aos="fade-up">
            <Link to="/about" className="blog-back">← Back to About</Link>
            <span className="page-hero-tag">Compliance Guide</span>
            <h1 className="page-hero-title">
              RBI Guidelines for <em>Default Loan Recovery</em>
            </h1>
            <p className="page-hero-sub">
              A comprehensive overview of the Reserve Bank of India's Fair Practices Code
              governing ethical debt collection in India.
            </p>
            <div className="page-hero-divider" />
          </div>

          <div className="blog-cover" data-aos="fade-up">
            <img src={guidelinesImg} alt="RBI guidelines for debt recovery India — CSR Associates" />
          </div>

          <article className="blog-article" data-aos="fade-up">
            <section>
              <h2>Overview: The RBI Fair Practices Code</h2>
              <p>
                The Reserve Bank of India's Fair Practices Code (FPC) establishes the framework
                within which all banks, NBFCs, and their authorised collection agencies must operate
                when recovering defaulted loans. First introduced in 2003 and significantly
                strengthened in subsequent circulars, the FPC is not merely advisory — it is a
                binding regulatory requirement with real consequences for non-compliance.
              </p>
              <p>
                At CSR Associates, adherence to the FPC is foundational to every recovery engagement.
                Understanding these guidelines protects our clients' reputations and ensures
                sustainable, legally sound recovery operations.
              </p>
            </section>

            <section>
              <h2>1. Communication Standards</h2>
              <p>
                Collection agents may only contact borrowers between <strong>8:00 AM and 7:00 PM</strong>.
                Contact outside these hours constitutes a violation regardless of the borrower's outstanding
                amount. All communications must identify the agent and the institution they represent.
                Calls, visits, and written correspondence must be professional and factual — no threatening,
                abusive, or misleading language is permitted under any circumstance.
              </p>
            </section>

            <section>
              <h2>2. Prohibition on Harassment</h2>
              <p>
                The RBI explicitly prohibits any form of physical intimidation, psychological pressure,
                or harassment of the borrower or their family members. This includes repeated calls
                designed to disturb, disclosure of the borrower's debt status to unauthorised parties,
                and any conduct calculated to cause mental distress. Collection agencies and their
                employees face personal liability for violations of these provisions.
              </p>
            </section>

            <section>
              <h2>3. Authorisation Requirements</h2>
              <p>
                Collection agents must carry valid authorisation letters from the lending institution
                when conducting field visits. Borrowers have an absolute right to verify the agent's
                identity and credentials before engaging. At CSR Associates, all field executives
                carry up-to-date authorisation documentation and have undergone police-verified
                background checks — providing our clients with full audit trail compliance.
              </p>
            </section>

            <section>
              <h2>4. Grievance Redressal</h2>
              <p>
                Borrowers retain the right to raise complaints against both the lending institution
                and its collection agents. Complaints must be acknowledged within 30 days and
                resolved fairly. The RBI's Sachet portal (sachet.rbi.org.in) provides an additional
                escalation pathway for unresolved grievances — a resource we actively communicate
                to borrowers as part of our commitment to transparency.
              </p>
            </section>

            <section>
              <h2>5. Documentation and Record-Keeping</h2>
              <p>
                All recovery actions must be documented. This includes visit records, communication logs,
                payment receipts, and settlement agreements. Proper documentation protects both the
                lender and the borrower, creates clear audit trails for regulatory inspection, and
                prevents disputes over amounts paid or agreed upon.
              </p>
            </section>

            <section>
              <h2>CSR Associates: Built on Compliance</h2>
              <p>
                Every process at CSR Associates is designed around these guidelines. Our training
                programmes, quality monitoring systems, and escalation procedures are all calibrated
                to ensure zero regulatory violations across our 500+ client engagements.
                Compliance is not a constraint on our recovery operations — it is the foundation
                that makes our outcomes sustainable and our client relationships enduring.
              </p>
            </section>

            <div className="blog-cta">
              <h3>Need Compliant Recovery Services?</h3>
              <p>CSR Associates — ethical, RBI-compliant debt recovery since 2012.</p>
              <Link to="/contact" className="btn-gold">Partner With Us</Link>
            </div>
          </article>
        </div>
      </div>
    </>
  );
}
